export default function Header() {
	return (
		<header className="h-24 w-full flex justify-center items-center bg-gray-900">
			<h1 className="font-bold text-3xl text-white">
				Euchre <span className="font-thin">Online</span>
			</h1>
		</header>
	);
}
